import '@/Themes/Default/Styles/page-layout.scss';

import React, { MutableRefObject, useEffect, useRef } from 'react';
import { Card } from 'primereact/card';
import Header from '@/Components/Partials/Header';
import ContentLoadingTemplate from '@/Components/Templates/ContentLoadingTemplate';
import Footer from '@/Components/Partials/Footer';
import moment from "moment";
import { useAuth0 } from "@auth0/auth0-react";
import DefaultGlobalToast from "@/Components/Notifications/DefaultGlobalToast";
import { Toast } from "primereact/toast";
import registerServiceWorker from "@/service-worker";

interface PageLayoutProps {
    children: React.ReactNode;
    loadingContent?: boolean;
}

const PageLayout = ({ children, loadingContent }:PageLayoutProps) => {
    const apiVersion = localStorage.getItem('api_version');
    const currentYear = moment().year();
    const { getAccessTokenSilently } = useAuth0();
    const toastRef: MutableRefObject<void> = useRef();
    const toastANRef = useRef();

    const registerSw = async () => {
        const accessToken = await getAccessTokenSilently();
        registerServiceWorker(toastANRef, accessToken);
    };

    useEffect(() => {
        registerSw();
    }, []);

    return (
        <div className="page-layout">
            <div className="header-wrapper">
                <div className="main-container">
                    <Header />
                </div>
            </div>

            <div className="flex flex-column align-items-center justify-content-between">
                <div className="main-wrapper-container">
                    <div className="main-container">
                        <Card className="main-card relative">
                            {children}

                            {loadingContent && <ContentLoadingTemplate />}
                        </Card>

                        <div className="main-footer flex justify-content-between mt-2">
                            <span className="text-sm">&copy; Nightingale by Bridgetech Group {currentYear}{apiVersion ? '. Version ' + apiVersion + '.' : ''}</span>
                            <span className="text-sm">
                                Powered by <a className="text-highlight" href="https://bridgetechautomotive.co.uk/" target="_blank" rel="noreferrer">Bridgetech Automotive</a>
                            </span>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
            <DefaultGlobalToast/>
            <Toast ref={toastRef}/>
            <Toast ref={toastANRef} className="cookies-notification" position="top-left"/>
        </div>
    );
};

export default PageLayout;
